import { boardLiveHttpClient, httpClient } from '@connectors/HttpClient'

export type ActiveUsersGranularity = 'day' | 'week' | 'month'

export type GetActiveUsersParams = {
    startDate: string
    endDate: string
    granularity: ActiveUsersGranularity
}

export type ActiveUsersResponse = {
    rows: {
        periodStart: string
        activeUsers: number
    }[]
}

export const ReportsService = {
    get: async (): Promise<any> => {
        const response = await boardLiveHttpClient.axios.get('/api/board-live/admin/reports/clients')
        return response.data
    },
    getSeats: async (): Promise<any> => {
        const response = await httpClient.axios.get('/admin/reports/seats')
        return response.data
    },
    getActiveUsers: async (params: GetActiveUsersParams): Promise<ActiveUsersResponse> => {
        const response = await httpClient.axios.get('/admin/reports/active-users', {
            params
        })
        return response.data
    }
}
